import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";

export class StatoData {
  id?: number;
  nome?: string;

}

export class Stato {

  data:StatoData = {}

  constructor(data:StatoData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)
  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj("/api/regioni", queryParams);
      if(path) url.url += path;
      return url.toString()
   }

   static async getStati():Promise<Stato[]> {
     return new Promise((resolve, reject) => {
        ServerService.instance.getAll(Stato, `/api/stati`).then(res=>{
           resolve(res)
        }).catch(err=>{
           reject(err)
        })
     })
   }

}
